import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { apiMe, apiLogout, ApiError } from "../api/client";
const AuthCtx = createContext(null);
export function AuthProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [selectedCustomer, setSelectedCustomerState] = useState(() => localStorage.getItem("dragon_selected_customer"));
    const setSelectedCustomer = (slug) => {
        localStorage.setItem("dragon_selected_customer", slug);
        setSelectedCustomerState(slug);
    };
    const reload = useCallback(async () => {
        setLoading(true);
        try {
            const me = await apiMe();
            setUser(me);
            // Auto-select if user has exactly one customer or stored choice still valid
            const valid = me.accessible_customers.find(c => c.slug === selectedCustomer);
            if (!valid && me.accessible_customers.length > 0) {
                setSelectedCustomer(me.accessible_customers[0].slug);
            }
        }
        catch (e) {
            if (e instanceof ApiError && e.status === 401) {
                setUser(null);
            }
            else {
                // Surface unexpected errors but don't crash the shell
                console.error("auth reload failed", e);
                setUser(null);
            }
        }
        finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const logout = useCallback(async () => {
        try {
            await apiLogout();
        }
        catch { /* ignore */ }
        // Clear ALL SPA-side state that could leak across users on a shared
        // browser. aisearch_view (preference), aisearch_from (deep-link
        // post-OAuth target), and aisearch_prev_customer (banner revert)
        // would otherwise survive into the next user's session.
        localStorage.removeItem("dragon_selected_customer");
        localStorage.removeItem("aisearch_view");
        sessionStorage.removeItem("aisearch_from");
        sessionStorage.removeItem("aisearch_prev_customer");
        setUser(null);
        setSelectedCustomerState(null);
    }, []);
    useEffect(() => { reload(); }, [reload]);
    return (_jsx(AuthCtx.Provider, { value: { loading, user, selectedCustomer, setSelectedCustomer, reload, logout }, children: children }));
}
export function useAuth() {
    const c = useContext(AuthCtx);
    if (!c)
        throw new Error("useAuth requires AuthProvider");
    return c;
}
